import { useEffect, useReducer } from 'react';
import reducer from './reducer';
import getActions from './getActions';
import { ITopUnderwritersState } from '@/creditflowresearch/application/League/interfaces';
import { useLeagueTableFiltersContext } from '@/creditflowresearch/application/League/Table/LeagueTableFiltersContext';

interface IProps {
  topUnderwritersInitialState: ITopUnderwritersState,
}

export default ({ topUnderwritersInitialState }:IProps) => {
  const [state, dispatch] = useReducer(reducer, topUnderwritersInitialState);
  const { page, perPage } = state;
  const { state: filtersState } = useLeagueTableFiltersContext();
  const selectedPeriod = filtersState.periods.topUnderwriters.selected;

  const actions = getActions({ page, perPage, selectedPeriod }, dispatch);

  useEffect(() => {
    const { data: collection, totalCount } = topUnderwritersInitialState;

    actions.setTopUnderwritersData({ collection, totalCount });
  }, [topUnderwritersInitialState]);

  return {
    state,
    ...actions,
  };
};
